import React from 'react';
import SelectDropdown from './SelectDropdown.js';

export default function Filters({
  primalCuts,
  cookingMethods,
  setPrimalCuts,
  setCookingMethods
}) {
  return (
    <section className="section section--lg">
      <div className="cuts-filter" id="cuts-filter">
        <div className="grid grid--middle">
          <div className="grid__col-xs-12 grid__col-lg-4">
            <h3 className="montserrat-bold">Browse the Cuts</h3>
          </div>
          <div className="grid__col-xs-12 grid__col-sm-6 grid__col-lg-4">
            <div className="form__field">
              <label className="form__label">Primal Cuts</label>
              <SelectDropdown
                listItems={primalCuts}
                setStateHandler={setPrimalCuts}
              />
            </div>
          </div>
          <div className="grid__col-xs-12 grid__col-sm-6 grid__col-lg-4">
            <div className="form__field">
              <label className="form__label">Cooking Methods</label>
              <SelectDropdown
                listItems={cookingMethods}
                setStateHandler={setCookingMethods}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
